import styled from "styled-components";

export const TextareaStyles = styled.div`
  width: 100%;

  .textarea {
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    box-sizing: border-box;
    border-radius: ${({ theme }) => theme.radius[4]};
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};

    color: ${({ theme }) => theme.colors.semantic.text.strong};
    padding: ${({ theme }) => theme.spacing[8]};
    height: 162px;
    min-height: 162px;
    max-height: 162px;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    resize: none;
    outline: none;
  }

  .textarea:focus {
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .branchDescription {
    height: 100px;
    min-height: 100px;
    max-height: 100px;
  }

  .branchSpeciality {
    height: 70px;
    min-height: 70px;
    max-height: 70px;
  }

  .error {
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.error} !important;
  }

  .textarea::placeholder {
    opacity: 0.5;
  }

  .errorMessage {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.caption.c1.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b1.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.error};
    margin-top: ${({ theme }) => theme.spacing[4]};
    height: 24px;
  }
`;
